import clubPlaceholder from '../assets/club/shield_none.png';

export const FRONTEND_ASSET_HOST = 'https://frontend-assets.sorare.com';
export const ASSETS_HOST = 'https://assets.sorare.com';

export const PLAYER_PLACEHOLDER = `${FRONTEND_ASSET_HOST}/placeholders/player.png`;
export const CLUB_PLACEHOLDER = clubPlaceholder;
